<template>
  <HeartIcon
    v-bind="$attrs"
    :filled="canUseWishlist && wishlistStore.hasItems"
    :color="color"
    :label-aria="$t('nav.wishlist.aria-label')"
    role="link"
    @click="toggle"
  />
</template>
<script lang="ts" setup>
import HeartIcon from '~/components/base/HeartIcon.vue'
import { useWishlist } from '~/composables/roles'
import { useWishlistStore } from '~/stores/wishlist'

defineProps<{
    color?: string,
}>()

const emits = defineEmits<{
  (e: 'on-login', path: string): void
}>()

const router = useRouter()

const onLogin = () => {
  emits('on-login', '/account/lists')
}

const { canUseWishlist } = useWishlist()
const toggle = () => {
  if (!canUseWishlist.value) {
    onLogin()
  } else {
    router.push({ name: 'account-lists' })
  }
}
const wishlistStore = useWishlistStore()

const { processAction } = useAction()

onMounted(() => {
  if (canUseWishlist.value) {
    processAction(async () => {
      await wishlistStore.fetchAllItems()
    })
  }
})

</script>
<style lang="scss" scoped>
:deep(span) {
    width: 100%;
    height: 100%;
}
</style>
